import { UploadOutlined } from '@ant-design/icons';
import { App, Button, Space, Typography, Upload } from 'antd';
import React from 'react';
import { parkApi } from '@/services/bff/park.api';
import type { InvestmentOrderStatus } from '@/services/bff/types/investment-order';
import type { ServiceFile } from '@/services/bff/types/park';

export const businessTypes = [
  { value: 'lease', label: '实际租赁' },
  { value: 'affiliation', label: '孵化挂靠' },
  { value: 'talent', label: '人才服务' },
  { value: 'technology', label: '科技服务' },
  { value: 'sale', label: '出售' },
  { value: 'parking', label: '车位租赁' },
  { value: 'meeting_room', label: '会议室租赁' },
  { value: 'activity', label: '活动合作' },
  { value: 'procurement', label: '采购' },
];
export const orderStatuses: Record<
  InvestmentOrderStatus,
  { text: string; status?: string }
> = {
  draft: { text: '待传资料', status: 'Default' },
  pending_finance: { text: '待财务审核', status: 'Processing' },
  finance_rejected: { text: '财务退回', status: 'Error' },
  finance_approved: { text: '财务通过', status: 'Success' },
  completed: { text: '已办结', status: 'Success' },
};
export const formatMoney = (value?: number | null) =>
  value == null
    ? '—'
    : `¥${Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// Contract files use a dedicated endpoint. Generic file preview must never bypass approval.
export const ContractUpload: React.FC<{
  value?: ServiceFile | null;
  onChange?: (file: ServiceFile | null) => void;
  word?: boolean;
  paymentProof?: boolean;
  disabled?: boolean;
  onUploadingChange?: (uploading: boolean) => void;
}> = ({ value, onChange, word, paymentProof, disabled, onUploadingChange }) => {
  const { message } = App.useApp();
  const [uploading, setUploading] = React.useState(false);
  return (
    <Space direction="vertical">
      <Upload
        accept={
          paymentProof
            ? '.jpg,.jpeg,.png,.webp'
            : word
              ? '.doc,.docx'
              : '.pdf,.doc,.docx,.jpg,.jpeg,.png'
        }
        showUploadList={false}
        disabled={disabled || uploading}
        beforeUpload={async (file) => {
          setUploading(true);
          onUploadingChange?.(true);
          try {
            onChange?.(await parkApi.uploadFile(file, 'investment_order'));
          } catch (e: any) {
            message.error(e?.message || '合同上传失败');
          } finally {
            setUploading(false);
            onUploadingChange?.(false);
          }
          return Upload.LIST_IGNORE;
        }}
      >
        <Button
          icon={<UploadOutlined />}
          loading={uploading}
          disabled={disabled}
          style={{ boxShadow: 'none' }}
        >
          {value
            ? paymentProof
              ? '替换付款截图'
              : '替换合同文件'
            : paymentProof
              ? '上传首期款付款截图'
              : word
                ? '上传待审 Word 合同'
                : '上传签署合同'}
        </Button>
      </Upload>
      {value && (
        <Space wrap>
          <Typography.Text>{value.fileName}</Typography.Text>
          <Button
            size="small"
            type="text"
            disabled={disabled || uploading}
            style={{ boxShadow: 'none' }}
            onClick={() => onChange?.(null)}
          >
            移除
          </Button>
        </Space>
      )}
    </Space>
  );
};
